import request from '@/libs/request'
// 登录
export function login (data) {
  return request({
    url: `login`,
    method: 'post',
    data
  })
}
// 用户列表
export function userList (data) {
  return request({
    url: `user/list`,
    method: 'get',
    params: data
  })
}
// 改变用户状态
export function changeUserStatusApi (data) {
  return request({
    url: `user/changeStatus`,
    method: 'post',
    data: data
  })
}

// 返回权限
export function getUserInfo () {
  return request({
    url: 'getAuth',
    method: 'get'
  })
}

// 用户信息
export function userInfo (id) {
  return request({
    url: `user/info/${id}`,
    method: 'get'
  })
}

export function getAllRole (user_id) {
  return request({
    url: `user/getAllRole/${user_id}`,
    method: 'get'
  })
}

export function userEdit (data) {
  return request({
    url: `user/edit`,
    method: 'post',
    data
  })
}

export function exportData (data) {
  return request({
    url: `user/exportInfos`,
    method: 'post',
    data
  })
}
export function agentList () {
  return request({
    url: `agentGroup/getAllGroup`,
    method: 'get'
  })
}
